import { render, staticRenderFns } from "./SeckillDetails.vue?vue&type=template&id=ae830d98&scoped=true&"
import script from "./SeckillDetails.vue?vue&type=script&lang=js&"
export * from "./SeckillDetails.vue?vue&type=script&lang=js&"
import style0 from "./SeckillDetails.vue?vue&type=style&index=0&id=ae830d98&scoped=true&lang=css&"
import style1 from "./SeckillDetails.vue?vue&type=style&index=1&id=ae830d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae830d98",
  null
  
)

export default component.exports